// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"15664": "8ec653be5662","16954": "e8a8cc814315","35465": "d1d6e75af28f","44872": "d1d6e75af28f","57933": "72e12e5c3e03","80333": "d1d6e75af28f","8169": "dee7c48157e2","97382": "bd7bdc62d523",}[chunkId] + ".css"
}